import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";  // ✅ Import Link
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";

import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <Container>
        <Row className="py-4">
          {/* Company Info */}
          <Col md={4} className="mb-4 mb-md-0">
            <h4 className="footer-logo">DevSkillz Learning Hub</h4>
            <p>
              Empowering students with the latest technology skills and guiding 
              them towards successful careers in the tech industry.
            </p>
            <p className="footer-address">
              Address: First Floor, Plot no 21, Beach Rd, Kirlampudi Layout, Chinna Waltair, Pedda Waltair, Visakhapatnam, Andhra Pradesh 530017
            </p>
          </Col>

          {/* Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5>Quick Links</h5>
<ul className="footer-links">
  <li>
    <a
      href="https://merchant.razorpay.com/policy/RWQUunqOQj3hPc/terms"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms & Conditions
    </a>
  </li>

  <li>
    <a
      href="https://merchant.razorpay.com/policy/RWQUunqOQj3hPc/refund"
      target="_blank"
      rel="noopener noreferrer"
    >
      Cancellation & Refund Policy
    </a>
  </li>

  <li>
    <a
      href="https://merchant.razorpay.com/policy/RWQUunqOQj3hPc/shipping"
      target="_blank"
      rel="noopener noreferrer"
    >
      Shipping & Delivery Policy
    </a>
  </li>

  {/* <li>
    <a
      href="/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </a>
  </li> */}
</ul>


          </Col>

          {/* Contact & Social */}
          <Col md={4}>
            <h5>Contact Us</h5>
            <p>Email: Teamhr@devskillz.in</p>
            <p>Phone: +91 6301792437</p>

            <p><Link to="/ManagerLogin">Manager Login</Link></p>
            {/* <p><Link to="/EmployeeLogin">Employee Login</Link></p> */}
            {/* <p><Link to="/StudentRegister">Student Register</Link></p> */}

            <div className="social-icons">
              {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <FaTwitter />
              </a> */}
              <a href="https://www.linkedin.com/company/devskillz-learning-hub/" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
              <a href="https://www.instagram.com/devskillz_learning_hub?igsh=MXQ5eW92cjF2bTQ1ag==" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://www.youtube.com/@devskillzlearninghub" target="_blank" rel="noopener noreferrer">
                <FaYoutube />
              </a>
              <a href="https://chat.whatsapp.com/HlTJjDjT6CnEX0N1o3EL4w" target="_blank" rel="noopener noreferrer">
                Join Our Community
              </a>
            </div>
          </Col>
        </Row>

        {/* Bottom Bar */}
        <Row className="pt-3 border-top">
          <Col className="text-center">
            <p className="mb-0">
              © {new Date().getFullYear()} DevSkillz. All Rights Reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
